Object.defineProperty(exports, "__esModule", { value: true });
exports.After = exports.Before = exports.HookError = exports.fieldBeforeHooksRegistry = exports.fieldAfterHooksRegistry = void 0;
const registry_1 = require("./registry");
var registry_2 = require("./registry");
Object.defineProperty(exports, "fieldAfterHooksRegistry", { enumerable: true, get: function () { return registry_2.fieldAfterHooksRegistry; } });
Object.defineProperty(exports, "fieldBeforeHooksRegistry", { enumerable: true, get: function () { return registry_2.fieldBeforeHooksRegistry; } });
var error_1 = require("./error");
Object.defineProperty(exports, "HookError", { enumerable: true, get: function () { return error_1.HookError; } });
function Before(hook) {
    return (targetInstance, fieldName) => {
        registry_1.registerFieldBeforeHook(targetInstance.constructor, fieldName, hook);
    };
}
exports.Before = Before;
function After(hook) {
    return (targetInstance, fieldName) => {
        registry_1.registerFieldAfterHook(targetInstance.constructor, fieldName, hook);
    };
}
exports.After = After;
//# sourceMappingURL=hooks.js.map